var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendcredentials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 6.66671H12.0007M10.6673 9.33337H12.0007M4.11398 10C4.25141 9.60938 4.50672 9.27101 4.84466 9.03165C5.18261 8.79229 5.58652 8.66373 6.00065 8.66373C6.41478 8.66373 6.81869 8.79229 7.15664 9.03165C7.49458 9.27101 7.74989 9.60938 7.88732 10M7.33398 7.33337C7.33398 8.06975 6.73703 8.66671 6.00065 8.66671C5.26427 8.66671 4.66732 8.06975 4.66732 7.33337C4.66732 6.59699 5.26427 6.00004 6.00065 6.00004C6.73703 6.00004 7.33398 6.59699 7.33398 7.33337ZM2.66732 3.33337H13.334C14.0704 3.33337 14.6673 3.93033 14.6673 4.66671V11.3334C14.6673 12.0698 14.0704 12.6667 13.334 12.6667H2.66732C1.93094 12.6667 1.33398 12.0698 1.33398 11.3334V4.66671C1.33398 3.93033 1.93094 3.33337 2.66732 3.33337Z",
    stroke: "#FF8D2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendcredentials);
export default __webpack_public_path__ + "static/media/resendcredentials.f398063d4774347c7e89f39af985510a.svg";
export { ForwardRef as ReactComponent };